import axios from 'axios';

export const getHouseAllDevices = (houseId) => {
    return new Promise((resolve, reject) => {
        if (!houseId) {
            resolve([]);
            return;
        }
        axios
            .get(`/house/getalldevices/${houseId}`)
            .then((response) => {
                resolve(Array.isArray(response.data) ? response.data : []);
            })
            .catch(reject);
    });
};

export const getAllDeviceModels = () => {
    return new Promise((resolve, reject) => {
        axios
            .get('/devicemodel/getall')
            .then((response) => {
                console.log(response.data);
                const list = Array.isArray(response.data?.data)
                    ? response.data.data
                    : Array.isArray(response.data)
                        ? response.data
                        : [];
                resolve(list);
            })
            .catch(reject);
    });
};

export const searchDeviceModels = (query) => {
    console.log('searchDeviceModels', query);
    return new Promise((resolve, reject) => {
        axios
            .post('/devicemodel/search', { q: (query || '').trim() })
            .then((response) => {
                console.log(response.data);
                const list = Array.isArray(response.data)
                    ? response.data
                    : Array.isArray(response.data)
                        ? response.data
                        : [];
                resolve(list);
            })
            .catch((error) => {
                console.log(error);
                reject(error);
            });
    });
};

export const getAllDeviceTypes = () => {
    return new Promise((resolve, reject) => {
        axios
            .get('/devicetype/getall')
            .then((response) => {
                resolve(Array.isArray(response.data) ? response.data : []);
            })
            .catch(reject);
    });
};

export const createDevice = (payload) => {
    return new Promise((resolve, reject) => {
        axios
            .post('/device/create', payload)
            .then((response) => resolve(response.data))
            .catch(reject);
    });
};
